import axios, { AxiosPromise, AxiosRequestConfig } from 'axios'

const basePath = process.env.NEXT_PUBLIC_SSO_HOST

/**
 * Получение access токена WebSSO
 * @param config
 * @returns
 */
export const getTokenApi: (config: AxiosRequestConfig) => AxiosPromise<void> = (config) =>
  axios(`${basePath}/client-profile/get_mts_token`, config)

export const getMtsIDTokenApi: (config: AxiosRequestConfig) => AxiosPromise<{ mts_id_token: string }> = (config) =>
  axios(`${basePath}/api/get_mts_id_token`, config)
